export default {
  suppliersCountries: {
    loading: false,
    success: false,
    message: '',
    error: null,
    countries: [],
  },
  suppliers: {
    loading: false,
    success: false,
    message: '',
    error: null,
    suppliers: [],
  },
  transferConfirmation: {
    loading: false,
    success: false,
    message: '',
    error: null,
    data: {},
  },
  transferFund: {
    loading: false,
    success: false,
    message: '',
    error: null,
    data: {},
  },
  getBillsCategories: {
    loading: false,
    success: false,
    message: '',
    error: null,
    data: {},
  },
  verifyGatewayAccounts: {
    loading: false,
    success: false,
    message: '',
    error: null,
    data: {},
  },
};
